import { useEffect, useState } from 'react'
import { MeshGradient } from '@paper-design/shaders-react'
import { useFrameBudgetPause } from '../motion/frameBudget'
import { useTier } from '../motion/tiers'

/**
 * The single full-viewport ambient instance (R2). Paper Shaders is
 * pinned exactly — breaking changes ship under 0.0.x (plan risk note).
 * Paused (unmounted) in Work Mode / under the PRM clamp, while the tab
 * is hidden, and while the frame budget slips (provisional thresholds;
 * tuned in the U13 perf pass).
 */
const AMBIENT_COLORS = ['#04070a', '#0b2e26', '#0a2f3c', '#060a0d']

export function AmbientField() {
  const { isWork } = useTier()
  const [visible, setVisible] = useState(() => document.visibilityState === 'visible')

  useEffect(() => {
    const onVis = () => setVisible(document.visibilityState === 'visible')
    document.addEventListener('visibilitychange', onVis)
    return () => document.removeEventListener('visibilitychange', onVis)
  }, [])

  const active = !isWork && visible
  const overBudget = useFrameBudgetPause(active)
  if (!active || overBudget) return null

  return (
    <div className="v2-ambient" aria-hidden="true">
      <MeshGradient colors={AMBIENT_COLORS} speed={0.12} style={{ width: '100%', height: '100%' }} />
    </div>
  )
}
